import { Banner } from "../components/banner/Banner"
import { PageContainer } from "../components/pageContainer/PageContainer"
import { ContactForm } from "../layout/contactForm/ContactForm"
import ContactBan from '../assets/img/contact-ban.jpg'
import { Header } from "../components/header/Header"

export const Contact = () => {
    return (
        <PageContainer>
            <Banner img={ContactBan}></Banner>
            <Header>Reach Us</Header>
            <ContactForm></ContactForm>
        </PageContainer>
    )
}